/* eslint-disable max-params */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
import { appUrl, currentEnv, ppApiUrl } from "./url-constants";
import InternalListing from "../components/shared/images/classifieds/cars24-certified-active.png";
import DealerListing from "../components/shared/images/classifieds/dealer-active.png";
import InternalListingLogo from "../components/shared/images/classifieds/internal-listing-logo.svg";
import DealerListingLogo from "../components/shared/images/classifieds/dealer-listing-logo.svg";
import LuxuryIcon from "../../client/components/shared/images/luxury/Luxury.svg";

export const NUMBER = {
    ZERO: 0,
    DECIMAL_FIVE: 0.5,
    DECIMAL_ZERO_FIVE: 0.05,
    DECIMAL_EIGHT: 0.8,
    DECIMAL_NINE_POINT_SEVEN: 9.7,
    DECIMAL_ELEVEN_POINT_SEVEN: 11.7,
    DECIMAL_NINE_FIVE: 0.95,
    ONE: 1,
    TWO: 2,
    THREE: 3,
    FOUR: 4,
    FIVE: 5,
    SIX: 6,
    SEVEN: 7,
    EIGHT: 8,
    NINE: 9,
    TEN: 10,
    TWELVE: 12,
    THIRTEEN: 13,
    FOURTEEN: 14,
    FIFTEEN: 15,
    SIXTEEN: 16,
    EIGHTEEN: 18,
    NINETEEN: 19,
    TWENTY: 20,
    TWENTY_TWO: 22,
    TWENTY_FOUR: 24,
    TWENTY_FIVE: 25,
    TWENTY_EIGHT: 28,
    TWENTY_NINE: 29,
    THIRTY: 30,
    THIRTY_TWO: 32,
    THIRTY_THREE: 33,
    THIRTY_FOUR: 34,
    THIRTY_FIVE: 35,
    THIRTY_SEVEN: 37,
    THIRTY_EIGHT: 38,
    THIRTY_NINE: 39,
    FOURTY: 40,
    FOURTY_ONE: 41,
    FOURTY_THREE: 43,
    FOURTY_FIVE: 45,
    FOURTY_SIX: 46,
    FOURTY_EIGHT: 48,
    FIFTY: 50,
    FIFTY_ONE: 51,
    FIFTY_TWO_POINT_ONE_FOUR: 52.14,
    FIFTY_TWO_POINT_ONE_FOUR_TWO_NINE: 52.1429,
    FIFTY_SIX: 56,
    SIXTY: 60,
    EIGHTY: 80,
    SIXTY_FOUR: 64,
    SEVENTY_TWO: 72,
    NINETY: 90,
    HUNDRED: 100,
    ONE_FIFTY: 150,
    ONE_HUNDRED_FIFTY: 150, // Added from AU C2B
    TWO_HUNDRED: 200,
    TWO_HUNDRED_THIRTY: 230,
    TWO_HUNDRED_SEVENTY: 270,
    TWO_HUNDRED_EIGHTY: 280,
    THREE_HUNDERED_THIRTY: 330,
    ONE_HUNDRED_THIRTY_FOUR: 134,
    ONE_HUNDRED_SEVENTY_FOUR: 174,
    ONE_HUNDRED_EIGHTY: 180,
    THREE_HUNDRED: 300,
    FIVE_HUNDRED: 500,
    SIX_HUNDRED: 600,
    SIX_HUNDRED_FIFTY: 650,
    SEVEN_HUNDRED: 700,
    EIGHT_HUNDRER_FIFTY: 850,
    NINE_HUNDRED: 900,
    NINE_NINETY_NINE: 999,
    THOUSAND: 1000,
    ONE_THOUSAND_TWENTY: 1020, // Added from AU C2B
    TWO_THOUSAND: 2000,
    TWO_THOUSAND_FOURTEEN: 2014, // Added from AU C2B
    THREE_THOUSAND: 3000,
    FOUR_THOUSAND: 4000,
    FOUR_THOUSAND_FIVE_HUNDRED: 4500,
    FIVE_THOUSAND: 5000,
    FIVE_THOUSAND_FIVE_HUNDRED: 5500,
    SIX_THOUSAND: 6000,
    EIGHT_THOUSAND: 6000,
    TEN_THOUSAND: 10000,
    TWELVE_THOUSAND: 12000,
    FIFTEEN_THOUSAND: 15000,
    TWENTY_FIVE_THOUSAND: 25000,
    FIFTY_THOUSAND: 50000,
    SIXTY_FIVE_THOUSAND: 65000, // Added from AU C2B
    ONE_LAKH: 100000,
    ONE_LAKH_FORTY_THOUSAND: 140000, // Added from AU C2B
    ONE_LAKH_FIFTY_THOUSAND: 150000, // Added from AU C2B
    TEN_LAKH: 1000000,
    FOURTEEN_LAKH: 1400000, // Added from AU C2B
    THIRTY_LAKH: 3000000,
    NINETY_NINE_LAKH: 9900000,
    TWENTY_ONE: 21,
    TWENTY_SIX: 26,
    THIRTY_ONE: 31,
    THIRTY_SIX: 36,
    NINETEEN_SEVENTY: 1970,
    MINUS_TWENTY: -20,
    TWENTY_THOUSAND: 20000,
    FIFTY_FIVE_HUNDRED: 5500,
    FIFTEEN_HUNDRED: 1500,
    ONE_THOUSAND_TWELVE: 1012,
    ONE_THOUSAND_FOURTEEN: 1014,
    ONE_THOUSAND_THIRTEEN: 1013,
    ONE_THOUSAND_TWENTY_ONE: 1021, // Added from AU C2B
    ONE_THOUSAND_TWENTY_TWO: 1022, // Added from AU C2B
    ONE_THOUSAND_TWENTY_FIVE: 1025, // Added from AU C2B
    ONE_THOUSAND_TWENTY_SEVEN: 1027, // Added from AU C2B
    ONE_THOUSAND_THIRTY_ONE: 1031, // Added from AU C2B
    ONE_THOUSAND_THIRTY_TWO: 1032, // Added from AU C2B
    ONE_THOUSAND_FIFTY_ONE: 1051, // Added from AU C2B
    ONE_THOUSAND_FIFTY_FOUR: 1054, // Added from AU C2B
    ONE_THOUSAND_FIFTY_FIVE: 1055, // Added from AU C2B
    MINUS_TWO: -2,
    MINUS_THREE: -3,
    THOUSAND_SEVEN: 1007,
    THOUSAND_TWENTY_ONE: 1021,
    THREE_LAKH_FIFTY_THOUSAND: 350000,
    FIFTY_LAKH: 5000000,
    THIRTY_THOUSAND: 30000,
    FOUR_HUNDRED_FOUR: 404,
    FOUR_HUNDRED_ONE: 401,
    FOUR_HUNDRED_NINE: 409,
    THOUSAND_THREE: 1003,
    NINTY_NINE: 99,
    FOUR_HUNDRED: 400,
    FIFTY_TWO: 52,
    SEVENTY_THOUSAND: 70000,
    SEVEN_THOUSAND: 7000,
    ELEVEN: 11,
    SEVENTEEN: 17,
    TWENTY_THREE: 23,
    ONE_THOUSAND_ONE: 1001,
    ONE_THOUSAND_TWENTY_FOUR: 1024,
    ONE_THOUSAND_THIRTY_FIVE: 1035,
    FOUR_HUNDERED_THREE: 403,
    SIXTY_THOUSAND: 60000,
    ONE_TWENTY_EIGHT: 128,
    DECIMAL_ONE: 0.1,
    DECIMAL_ZERO_EIGHTEEN: 0.18,
    MINUS_FIFTY: -50,
    MINUS_HUNDRED: -100,
    MINUS_NINETY: -90,
    ONE_HUNDRED_THREE: 103,
    ONE_HUNDRED_TWO: 102,
    TWENTY_SEVEN: 27,
    ONE_HUNDRED_NINTY: 190,
    ONE_HUNDRED_TWENTY: 120,
    ONE_HUNDRED_SIXTEEN: 116,
    THREE_HUNDRED_SIXTY: 360,
    THREE_HUNDRED_SIXTY_FIVE: 365,
    NINE_LAKH_NINTY_NINE_THOUSAND_NINE_HUNDERED_NINTY_NINE: 999999,
    THIRTY_SIX_LAKH: 3600000,
    DECIMAL_ONE_TWO: 1.2,
    MILLION: 1000000,
    BILLION: 1000000000,
    ONE_HUNDRED_SEVENTY_SEVEN: 177
};

export const LEAD_GENERATION_FORM_CONFIG_KEYS = {
    DEFAULT: "loginConfig",
    COMING_SOON: "comingSoonConfig",
    TEST_DRIVE: "testDriveConfig"
};

export const resetReducerKeys = {
    RESET_CAR_FINDER: "RESET_CAR_FINDER",
    RESET_BRANDS: "RESET_BRANDS",
    RESET_MODELS: "RESET_MODELS",
    RESET_YEARS: "RESET_YEARS",
    RESET_VARIANTS: "RESET_VARIANTS",
    RESET_REGISTRATION_STATES: "RESET_REGISTRATION_STATES",
    RESET_KILOMETERS_DRIVEN: "RESET_KILOMETERS_DRIVEN",
    RESET_BLOGS: "RESET_BLOGS",
    RESET_TESTIMONIALS: "RESET_TESTIMONIALS",
    RESET_EXPERTS: "RESET_EXPERTS",
    RESET_FAQS: "RESET_FAQS",
    RESET_RECENTLY_INSPECTED: "RESET_RECENTLY_INSPECTED",
    RESET_FOOTER: "RESET_FOOTER",
    META_TAGS: "RESET_META_TAGS",
    RESET_NEWS: "RESET_NEWS",
    RESET_LEAD_DATA: "RESET_LEAD_DATA",
    RESET_SEO_MODELS: "RESET_SEO_MODELS",
    RESET_BRANCH_LOCATION: "RESET_BRANCH_LOCATION",
    RESET_CITIES: "RESET_CITIES",
    RESET_APPOINTMENT_LOCATION: "RESET_APPOINTMENT_LOCATION",
    RESET_APPOINTMENT_DETAILS: "RESET_APPOINTMENT_DETAILS",
    RESET_USER: "RESET_USER",
    RESET_LOCATION: "RESET_LOCATION",
    RESET_RESCHEDULE: "RESET_RESCHEDULE",
    RESET_CONFIRMATION_DETAILS: "RESET_CONFIRMATION_DETAILS",
    RESET_SETTINGS: "RESET_SETTINGS",
    RESET_WIDGET: "RESET_WIDGET",
    RESET_REVIEW: "RESET_REVIEW",
    RESET_BRANCH_LOCATOR: "RESET_BRANCH_LOCATOR",
    RESET_ONE_STEP_APPOINTMENT: "RESET_ONE_STEP_APPOINTMENT",
    RESET_REVIEW_DETAILS: "RESET_REVIEW_DETAILS",
    RESET_REVIEW_SUBMISSION: "RESET_REVIEW_SUBMISSION",
    RESET_RC_TRANSFER: "RESET_RC_TRANSFER",
    RESET_TOP_SELLING_USED_CARS: "RESET_TOP_SELLING_USED_CARS",
    RESET_NEED_HELP: "RESET_NEED_HELP",
    RESET_SEO_TESTIMONIALS: "RESET_SEO_TESTIMONIALS",
    RESET_RATED_TESTIMONIALS: "RESET_RATED_TESTIMONIALS",
    RESET_BRANCH_FILTER: "RESET_BRANCH_FILTER",
    RESET_TRUECALLER: "RESET_TRUECALLER",
    RESET_RTO_INFO: "RESET_RTO_INFO",
    RESET_LEAD_BRANCHES: "RESET_LEAD_BRANCHES",
    RESET_LEAD_BRANCH_DATE: "RESET_LEAD_BRANCH_DATE",
    RESET_LEAD_PROGRESS_BAR: "RESET_LEAD_PROGRESS_BAR",
    RESET_SEO_DETAILS: "RESET_SEO_DETAILS",
    RESET_AB_EXPERIMENTS: "RESET_AB_EXPERIMENTS",
    RESET_CAR_LIST: "RESET_CAR_LIST",
    RESET_FILTERS: "RESET_FILTERS",
    RESET_CONFIG: "RESET_CONFIG",
    RESET_FUEL_PRICE: "RESET_FUEL_PRICE",
    RESET_LEAD_RTO: "RESET_LEAD_RTO",
    RESET_CAR_DETAILS: "RESET_CAR_DETAILS",
    RESET_EXPLORE_USED_CARS: "RESET_EXPLORE_USED_CARS",
    RESET_SIMILAR_CARS: "RESET_SIMILAR_CARS",
    RESET_RECENTLY_VIEWED_CARS: "RESET_RECENTLY_VIEWED_CARS",
    RESET_SELECT_OFFER_PRICE: "RESET_SELECT_OFFER_PRICE",
    RESET_PARKING_YARD: "RESET_PARKING_YARD",
    FEATURED_CARS: "FEATURED_CARS",
    RESET_CONTENT_HOOK: "RESET_CONTENT_HOOK",
    RESET_LEGACY_LEAD_FORM: "RESET_LEGACY_LEAD_FORM",
    RESET_SELL_BIKE: "RESET_SELL_BIKE",
    RESET_SCRIPT_LOADER: "RESET_SCRIPT_LOADER",
    RESET_REFER: "RESET_REFER",
    RESET_FRANCHISE_FORM: "RESET_FRANCHISE_FORM",
    RESET_PARTNER_FORM: "RESET_PARTNER_FORM",
    RESET_LOAN_FORM: "RESET_LOAN_FORM",
    RESET_BIKE_FORM: "RESET_BIKE_FORM",
    RESET_BIKE_BRANDS: "RESET_BIKE_BRANDS",
    RESET_BIKE_BRANCHES: "RESET_BIKE_BRANCHES",
    RESET_BIKE_BRANCH_DATE: "RESET_BIKE_BRANCH_DATE",
    RESET_CLASSIFIED: "RESET_CLASSIFIED",
    MAKE_AN_OFFER: "MAKE_AN_OFFER",
    USED_CAR_LEAD_INFO: "USED_CAR_LEAD_INFO",
    RESET_MARKETING_LEAD_FORM: "RESET_MARKETING_LEAD_FORM",
    RESET_LEAD_BRANCH_SELECTIONS: "RESET_LEAD_BRANCH_SELECTIONS",
    RESET_TOP_SELLING_CARS: "RESET_TOP_SELLING_CARS",
    RESET_FEATURED_CARS: "RESET_FEATURED_CARS",
    RESET_EXCHANGE_CAR_DETAILS: "RESET_EXCHANGE_CAR_DETAILS",
    RESET_TOP_DEALS_REDUCER: "RESET_TOP_DEALS_REDUCER",
    RESET_LISTING_INFO: "RESET_LISTING_INFO",
    RESET_LOAN_CALCULATION_DATA: "RESET_LOAN_CALCULATION_DATA",
    RESET_BUYER_SELLER_DETAIL: "RESET_BUYER_SELLER_DETAIL",
    RESET_BIKE_RESCHEDULE: "RESET_BIKE_RESCHEDULE",
    RESET_BIKE_CONFIRMATION_DETAILS: "RESET_BIKE_CONFIRMATION_DETAILS",
    RESET_WISHLISTED_CARS: "RESET_WISHLISTED_CARS",
    RESET_WISHLISTED_LOGIN: "RESET_WISHLISTED_LOGIN",
    RESET_TOAST_MESSAGE: "RESET_TOAST_MESSAGE",
    RESET_CAR_FINDER_LISTING: "RESET_CAR_FINDER_LISTING",
    RESET_CAR_FINDER_CAR_LIST: "RESET_CAR_FINDER_CAR_LIST",
    RESET_CAR_SERVICES_DATA: "RESET_CAR_SERVICES_DATA",
    RESET_CAR_SERVICE_LEAD_FORM: "RESET_CAR_SERVICE_LEAD_FORM",
    RESET_CAR_SERVICE_INFO: "RESET_CAR_SERVICE_INFO",
    RESET_CAR_SERVICE_BOOK: "RESET_CAR_SERVICE_BOOK",
    RESET_LEAD_FUEL_TYPE: "RESET_LEAD_FUEL_TYPE",
    RESET_DEAL_PAYMENT_INFO: "RESET_DEAL_PAYMENT_INFO",
    RESET_CARS24_SELECT: "RESET_CARS24_SELECT",
    RESET_GS_BUY_CAR_DETAILS: "RESET_GS_BUY_CAR_DETAILS",
    RESET_CONSUMER_FINANCE: "RESET_CONSUMER_FINANCE",
    RESET_MY_BOOKINGS: "RESET_MY_BOOKINGS",
    RESET_LOCATION_PICKER_MODAL: "RESET_LOCATION_PICKER_MODAL",
    RESET_CHECKOUT: "RESET_CHECKOUT",
    RESET_CHAT_ICON: "RESET_CHAT_ICON",
    RESET_CALLBACK_DETAILS: "RESET_CALLBACK_DETAILS",
    RESET_C24Q_PRICE: "RESET_C24Q_PRICE",
    RESET_CUSTOMER_CAR_INSPECTION_PARAMETER: "RESET_CUSTOMER_CAR_INSPECTION_PARAMETER",
    SAVED_FILTERS: "SAVED_FILTERS",
    RESET_RECOMMENDED_CARS: "RESET_RECOMMENDED_CARS",
    RESET_DELIVERY_INFO: "RESET_DELIVERY_INFO",
    RESET_HOME_LIST: "RESET_HOME_LIST",
    RESET_SITEMAP_LIST: "RESET_SITEMAP_LIST",
    RESET_NUDGE_LIST: "RESET_NUDGE_LIST",
    RESET_AUC2B_TRADE_IN: "RESET_AUC2B_TRADE_IN",
    PRE_APPROVAL_LOAN: "PRE_APPROVAL_LOAN",
    RESET_HEADER: "RESET_HEADER",
    RESET_TRADE_IN: "RESET_TRADE_IN",
    RESET_USER_REGO_VIN: "RESET_USER_REGO_VIN",
    RESET_NO_KBB_TRADE_IN: "RESET_NO_KBB_TRADE_IN",
    RESET_FINANCE_POST_PAYMENT_REDUCER: "RESET_FINANCE_POST_PAYMENT_REDUCER",
    RESET_BOOKED_TASKS_REDUCER: "RESET_BOOKED_TASKS_REDUCER",
    RESET_BOOK_INSPECTION: "RESET_BOOK_INSPECTION",
    RESET_SUPPORT_WIDGET: "RESET_SUPPORT_WIDGET",
    RESET_GUEST_LOGIN: "RESET_GUEST_LOGIN",
    RESET_MAKE_MODEL_FLOW: "RESET_MAKE_MODEL_FLOW",
    RESET_PAYMENT_CONFIG: "RESET_PAYMENT_CONFIG",
    RESET_ADDONS: "RESET_ADDONS",
    RESET_CLP_DATA: "RESET_CLP_DATA",
    RESET_FINANCE_LANDING_PAGE: "RESET_FINANCE_LANDING_PAGE",
    RESET_TEST_DRIVE: "RESET_TEST_DRIVE",
    RESET_CAR_VALUATION_CALCULATOR: "RESET_CAR_VALUATION_CALCULATOR",
    RESET_CAR_LOAN_CALCULATOR_CLP: "RESET_CAR_LOAN_CALCULATOR_CLP",
    RESET_PRICE_COMMUNICATION_PAGE: "RESET_PRICE_COMMUNICATION_PAGE",
    RESET_ROADWORHTY_CERTIFICATE: "RESET_ROADWORHTY_CERTIFICATE",
    RESET_VIDEO_GALLERY: "RESET_VIDEO_GALLERY",
    RESET_YARD_VISIT_FORM: "RESET_YARD_VISIT_FORM",
    RESET_CAR_HISTORY_REPORT: "RESET_CAR_HISTORY_REPORT",
    RESET_CAROUSEL_STORE: "RESET_CAROUSEL_STORE",
    RESET_DEALER: "RESET_DEALER",
    RESET_PRE_APPROVAL_ON_FLY: "RESET_PRE_APPROVAL_ON_FLY"

};

export const stringConstants = {
    YES: "yes",
    NO: "no"
};

//added undefiend for local env - has to tbe removed
const baseUrl = {
    privateProduct: {
        QA: "https://consumer-private-web-qa.ninja24.in/account",
        STAGING: "https://stage-c2b-website.qac24svc.dev/account",
        LNOD: "https://stage-c2b-website.qac24svc.dev/account",
        PRODUCTION: "https://www.cars24.com/account"
    },
    c2c: {
        QA: "http://c2cweb-qa.ninja24.in/buy-used-cars",
        STAGING: "https://stage-c2b-website.qac24svc.dev/buy-used-cars",
        // STAGING: "http://localhost:3000//buy-used-cars",
        LNOD: "https://stage-c2b-website.qac24svc.dev/buy-used-cars",
        PRODUCTION: "https://www.cars24.com/buy-used-cars"
    },
    c2bPHP: {
        STAGING: "https://staging.cars24.com",
        PRODUCTION: "https://www.cars24.com"
    }
};

export const redirect = {
    AUTH_LOGIN: `${baseUrl.privateProduct[currentEnv]}/login`,
    AUTH_APPOINTMENTS: `${baseUrl.privateProduct[currentEnv]}/appointments`,
    AUTH_BIDS: `${baseUrl.privateProduct[currentEnv]}/bids`,
    AUTH_PROFILE: `${baseUrl.privateProduct[currentEnv]}/profile`,
    c2C: (path = "") => `${baseUrl.c2c[currentEnv]}${path}`,
    CARS24_HOME: appUrl,
    BYE_BYE_DRIVE: `${appUrl()}/byebyedrive/`,
    BLOG: `${appUrl()}/blog`,
    RC_TRANSFER: `${appUrl()}/rc-transfer`,
    HOW_IT_WORKS: `${appUrl()}/how-it-works`,
    WE_ARE_HIRING: "https://cars24.recruitee.com/",
    FAQ: `${appUrl()}/faq`,
    FAQ_AE: `${appUrl()}/ae/faq`,
    HELP: `${appUrl()}/need-help`,
    BECOME_OUR_PARTNER: `${appUrl()}/become-our-partner`,
    BRANCHES: `${appUrl()}/centres`,
    CAR_LOAN: `${appUrl()}/car-loan`,
    TESTIMONIALS: `${appUrl()}/testimonials/`,
    GOOGLE_PLAY_STORE_APP: "https://play.google.com/store/apps/details?id=com.cars24.seller&hl=en_IN",
    APPLE_STORE_APP: "https://itunes.apple.com/in/app/cars24-sell-car-at-best-price/id1364492085?mt=8",
    FINANCIAL_SERVICES_TERMS_CONDITIONS: "https://img.24c.in/cars24/docs/finance/terms_&_conditions.pdf",
    CAR_SERVICE: `${appUrl()}/car-service?itm_source=car_service&itm_medium=nav_bar`,
    MY_BOOKINGS: `${appUrl()}/my-bookings`
};

export const OTP_MAX_LENGTH = 4;
export const OTP_MAX_LENGTH_EMAIL = 6;

export const HTTP_CODES = {
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    NOT_FOUND: 404,
    SUCCESS: 200,
    FOUND: 302,
    MOVED_PERMANENTLY: 301,
    PERMANENTLY_REMOVED: 410,
    INTERNAL_SERVER_ERROR: 500,
    GATEWAY_TIMEOUT: 504
};

export const LOCAL_STORAGE_KEYS = {
    userProfile: "userProfile",
    financeUniqueId: "financeUniqueId",
    financeScreen: "finance_screen",
    tradeInToggleGuide: "tradeInToggleGuide",
    seenAppointmentIds: "seenAppointmentIds",
    closedClpSaleNudge: "closedClpSaleNudge",
    seenTradeInBannerCount: "seenTradeInBannerCount",
    show_web_to_app_nudge: "showWeb2AppNudge",
    show_price_confidence_nudge: "showPriceConfidenceNudge",
    price_confidence_nudge_seen_count: "PriceConfidenceNudgeSeenCount",
    tradeInDesktopAU: "tradeInDesktopAU",
    tradeInMobileAU: "tradeInMobileAU",
    similarCarsSeenCount: "similarCarsSeenCount",
    hasVisited: "hasVisited",
    nudgeModalContentSeen: "nudgeModalContentSeen",
    preApprovalFlowDropped: "preApprovalFlowDropped",
    sectionUsedTimestamp: "sectionUsedTimestamp",
    fomoNudgeSeenCount: "fmNudgeSeenCount",
    fomoNudgeClosed: "fmNudgeClosed",
    priorityClosedCount: "au_pcc",
    whislistPageNudge: "wishlistPageNudge",
    FOMO_NUDGE_SEEN_COUNT: "fomo_nudge_seen_count",
    PRIORITY_ADDED: "priority_added"
};

export const SESSION_KEYS = {
    S20_ORIENTATION_CHANGE_MESSAGE: "S20_ORIENTATION_CHANGE_MESSAGE",
    PRICE_CONFIDENCE_NUDGE_STATE: "price_confidence_nudge_state", // {} stores modal seen state and nudge closed state
    TEST_DRIVE_FINANCE_QUOTES_COACHMARK: "test_drive_finance_quotes_coachmark",
    MOBILE_BOTTOM_ANIMATION_CLICKED: "mobile_bottom_animation_clicked",
    CLOSED_TEST_DRIVE_STRIP_NUDGE: "CLOSED_TEST_DRIVE_STRIP_NUDGE",
    CATEGORY_NUDGE_COUNT: "CATEGORY_NUDGE_COUNT"
};

export const FEATURE_FLAG_KEYS = {
    KBB_FEATURE_FLAG: "kbbFeatureFlag",
    CHECKOUT_REVAMP: "checkoutRevampFlag",
    BUY_WARRANTY: "buyWarrantyFlag",
    DELIVERY_TIMELINE: "deliveryTimeLineFlag",
    TEST_DRIVE_FLAG: "testDriveFlag"
};

export const COOKIE_SEARCH_KEYWORDS = "c2b-searched-keywords";

export const RECENTLY_APPLIED_FILTERS = "c2b-recently-applied-filters";

export const IGNORE_PRIVATE_PRODUCT_APIS = [`${ppApiUrl()}/pp/ums/users`];

export const LEAD_FORM = {
    DEFAULT: "default",
    ONE_STEP: "oneStep",
    BIKE: "bike",
    MARKETING: "marketing",
    CARFINDER: "carfinder",
    CAR_SERVICE: "carService",
    FINANCE_FORM: "financeForm"
};

export const LOCATION_REQUEST_TYPE = {
    COORDINATES: "coordinates",
    PLACE: "place"
};

export const MAP_TYPE = {
    GOOGLE: "googlemap",
    MMI: "mapmyindia"
};

export const DISPOSITION_STATUS = {
    SOLD: "SOLD",
    PUBLISHED: "PUBLISHED",
    BOOKED: "BOOKED",
    LOST: "LOST",
    RE_PUBLISH: "RE-PUBLISH",
    RE_PUBLISH_1: "RE_PUBLISH",
    AUCTIONED: "AUCTIONED",
    REJECTED: "REJECTED",
    DRAFT: "DRAFT"
};

export const DEFAULT_C2C_CITY = {
    city_id: "8597",
    city_name: "Delhi-NCR",
    city_slug: "delhi-ncr",
    pincode: "110001"
};

export const AD_TYPE = {
    INSTANTLY_AVAILABLE: "instantlyAvailable",
    MONEYBACK_GUARANTEE: "moneybackGuarantee",
    GET_CAR_PRICE: "getCarPrice",
    FINANCE_AVAILABLE: "financeAvailable",
    WARRANTY_AVAILABLE: "warrantyAvailable",
    PRICE_DROP_AVAILABLE: "priceDropAvailable",
    VIEW_360_AVAILABLE: "view360Available",
    CAR_FINDER: "carFinder",
    DEAL_RATING: "dealRating"
};

export const CAR_LIST_EVENT_NAMES = {
    LISTING: "Buy_used_cars_C2C_Car_Listing_Page",
    B2C_LISTING: "Buy_used_cars_B2C_Car_Listing_Page",
    MONEYBACK: "Buy_used_cars_C2C_Car_Listing_Page_Moneyback",
    INSTANTLY_AVAILABLE: "Buy_used_cars_C2C_Car_Listing_Page_Instantly_Available",
    FINANCE_AVAILABLE: "Buy_used_cars_C2C_Car_Listing_Page_Finance_Available",
    PRICE_DROP: "Buy_used_cars_C2C_Car_Listing_Page_Price_Drop",
    HOME_PAGE: "Buy_used_cars_C2C_Car_Home_Page",
    SELL_VALUATION_PAGE: "Sell_valuation_page",
    B2C_HOME_PAGE: "Buy_used_cars_B2C_Homepage",
    FILTER_PAGE: "Buy_used_cars_C2C_filter_page",
    DETAILS: "Buy_used_cars_C2C_Car_Details_Page",
    VIEW_360_AVAILABLE: "Buy_used_cars_C2C_Car_Listing_Page_View_360_Available",
    WHISLIST: "Buy_used_cars_C2C_Whislist_page",
    DETAIL_SIMILAR_CARS: "Buy_used_cars_C2C_Car_detail_page_similiar_cars",
    MY_ACCOUNT: "Buy_used_cars_B2C_my_account",
    CAR_COMPARISSION_CDP: "Buy_used_cars_car_comparission_cdp",
    FINANCE_PAGE: "Buy_used_cars_finance_page",
    LISTING_PAGE: "listing",
    PAGE_HOME: "HomePage",
    DETAIL_PAGE: "Detail page",
    SEARCH_RESULT: "Search Result",
    WISH_LIST: "Wishlist",
    TEST_DRIVE_FINANCE: "TD_finance",
    CLP_LOAN_CALCULATOR: "clp_loan_calculator",
    DEALER_CARS: "dealer_cars"
};
export const WISHLIST_SOURCE_TYPES = {
    CLP: "clp",
    HOMEPAGE: "homepage",
    CDP: "cdp",
    WISHLIST: "wishlist",
    RECCENTLY_ADDED_CARS: "reccently added cars",
    RECENTLY_VIEWED_CARS: "recently viewed cars",
    SIMILAR_CAR_LIST: "similar car list",
    DEALER_CARS: "dealer cars"
};

export const AB_TEST_VARIATIONS = {
    VARIANT: "VARIANT",
    VARIANT_A: "VARIANT_A",
    VARIANT_B: "VARIANT_B",
    TEST: "Test",
    CONTROL: "Control",
    CONTROL_TEST: "Control-Test",
    NON_TG: "Non TG"
};

export const APPOINTMENT_TYPE = {
    BRANCH: "branch",
    HOME: "inspection",
    CRM: "CRM"
};

export const FORM_TYPE = {
    CAR: "car",
    BIKE: "bike",
    CLASSIFIED_RESCHEDULE: "classified_reschedule",
    ONE_STEP: "one_step",
    BIKE_RESCHEDULE: "bike_reschedule",
    PAYWALL_BOOK_NOW: "paywall_book_now",
    PAYWALL_MAKE_OFFER: "paywall_make_offer",
    GS_BOOK_NOW: "gs_book_now",
    TOKEN_PAYMENT: "token_payment",
    VONE_STEP: "vone_step",
    CHECKOUT: "checkout"
};

export const INACTIVE_CAR_STATES = [
    DISPOSITION_STATUS.LOST,
    DISPOSITION_STATUS.SOLD,
    DISPOSITION_STATUS.DRAFT,
    DISPOSITION_STATUS.AUCTIONED,
    DISPOSITION_STATUS.REJECTED
];

export const COOKIE_KEYS = {
    CAR_SERVICE_FIRST_CLICK_URL: "car_service_first_click_url",
    KBB_BANNER_SEEN_COUNT: "kbb_banner_seen_count",
    CLOSED_CLP_SALE_NUDGE: "close_clp_sale_nudge",
    CLP_SALE_ANIMATION_SEEN: "clp_sale_animation_seen",
    SEEN_INTERSTATE_MODAL: "seen_interstate_modal",
    FOMO_NUDGE_SEEN_COUNT: "fomo_nudge_seen_count",
    USER_COORDINATES: "user_coordinates",
    CLASSIFIED_HANDPICKED_BANNER_CLOSED: "classified_handpicked_banner_closed",
    GEODATA: "geodata",
    LUXURY_MODAL_SEEN: "luxury_modal_seen",
    LUXURY_HOME_STRIP_CLOSED: "luxury_home_strip_closed",
    TOKEN: "bifrost_token",
    REFRESH_TOKEN: "bifrost_refresh_token",
    WEB_TOKEN: "token",
    LEGACY_TOKEN: "token",
    LEGACY_REFRESH_TOKEN: "refresh_token",
    USER_EMAIL: "userEmail",
    USER_ID: "userId",
    USER_NAME: "userName",
    USER_TOKEN: "userToken"
};

export const PAYMENT_OPTIONS = {
    FINANCE: "FINANCE",
    CASH: "CASH",
    BO__FINANCE: "BO__FINANCE",
    BO__CASH: "BO__CASH",
    BO__BYO: "BO__BYO"
};

export const ANGLE = {
    ZERO: 0,
    NINETY: 90,
    HUNDRED_EIGHTY: 180,
    TWO_HUNDRED_SEVENTY: 270,
    THREE_HUNDRED_SIXTY: 360
};

export const DEFAULT_CITY = {
    AE: {
        city_id: "73662522",
        city_name: "Dubai",
        city_slug: "dubai",
        code: "CC_AE_1"
    },
    IN: {
        city_id: "8597",
        city_name: "Delhi-NCR",
        city_slug: "delhi-ncr"
    },
    AU: {
        city_id: "",
        city_name: "Brisbane",
        code: "BNE100",
        pincode: 4000,
        city_slug: "brisbane"
    }
};

export const COUNTRY = {
    name: "Australia",
    slug: "australia",
    id: "",
    code: "au"
};

export const CURRENCY = {
    IN: "₹",
    AE: "AED",
    AU: "$"
};

export const COUNTRY_CODE = {
    IN: "IN",
    AE: "AE",
    AU: "AU"
};

export const AU_HOMEPAGE_PAGINATION_SIZE = 6; // Updated from AU C2B (was 5)
export const MY_BOOKINGS_PAGINATION_SIZE = 20;
export const AU_CITY = "au_city";
//todo: remove duplicated constant
export const DEFAULT_AU_CITY_CODE = DEFAULT_CITY.AU.code;
export const DEFAULT_AU_PINCODE = DEFAULT_CITY.AU.pincode;
export const DEFAULT_AU_CITY_NAME = DEFAULT_CITY.AU.city_name; // Added from AU C2B

export const WHATSAPP_NUMBER_AU = { label: "+12013503301", value: "12013503301" };
export const HELPLINE_NUMBER_AU = { label: "1800 227 724", value: "1800 227 724" };
export const C2B_HELPLINE_NUMBER_AU = { label: "+61 482 091 942", value: "+61 482 091 942" };
export const C2B_INSPECTION_HELPLINE_AU = { label: "+61 482 077 377", value: "+61 482 077 377" };
export const FINANCE_EMAIL_AU = "financing.au@cars24.com";
export const SMS_NUMBER_AU = { label: "0488 825 496", value: "0488825496" };
export const SUPPORT_EMAIL = "hello.au@cars24.com"; // Updated from AU C2B which has different email

export const PHONE_COUNTRY_CODE = 61;

export const EXTERNAL_LINKS = {
    DRIVA_POLICY: "https://www.driva.com.au/legal",
    CAREERS_LINK: "https://www.linkedin.com/jobs/cars24-australia-jobs-worldwide?f_C=73063943&trk=top-card_top-card-primary-button-top-card-primary-cta&position=1&pageNum=0",
    WORKABLE_CAREER_LINK: "https://apply.workable.com/cars24/?lng=en",
    VICTORIA_HUB_MAP_LINK: "https://www.google.com/maps/place/CARS24+Melbourne+-+Buy,+Sell+%26+Finance+Used+Cars/@-37.837982,144.7913795,17z/data=!4m15!1m8!3m7!1s0x6ad661e523126b7f:0x9aa78a73d98bc41f!2s118+Cherry+Ln,+Laverton+North+VIC+3026,+Australia!3b1!8m2!3d-37.8379863!4d144.7939544!16s%2Fg%2F11c4jjhjlt!3m5!1s0x6ad6617696168445:0xf55bfeb22f39c563!8m2!3d-37.838041!4d144.7936896!16s%2Fg%2F11t_t81d6v?entry=ttu"
};

export const API_SOURCE = {
    M_SITE: "mSite",
    WEB_APP: "WebApp",
    DESKTOP: "Desktop",
    ANDROID: "App-Android",
    IOS: "App-iOS"
};

export const LOAN_PROVIDER = {
    DRIVA: "DRIVA",
    BYOF: "BYOF",
    CARS24: "CARS24",
    NONE: "NONE"
};

export const WARRANTY_PROVIDER = {
    CARS24: "CARS24",
    INTEGRITY: "INTEGRITY",
    AWN: "AWN"
};

export const PAYMENT_HISTORY_STATUS = {
    INITIATED: "INITIATED",
    SUCCESS: "SUCCESS"
};

export const WARRANTY_TERMS_CONDITION = "https://drive.google.com/file/d/1ywLYzVTXImB8QJfl-J9WtXmB7DtBTIE8/view?usp=sharing"; // Updated to use main file URL

export const DEFAULT_CITY_PINCODE_MAP = {
    NSW: 2000,
    VIC: 3000,
    QLD: 4000,
    SA: 5000
};
export const MEDIA_SOURCE = {
    helloAR: "helloAR",
    s20: "s20"
};

export const DEFAULT_TENURE = [
    {
        label: "36",
        value: 36
    },
    {
        label: "48",
        value: 48
    },
    {
        label: "60",
        value: 60
    },
    {
        label: "84",
        value: 84
    }
];

export const DEFAULT_TENURE_MSITE = [
    {
        label: "3",
        value: 36
    },
    {
        label: "4",
        value: 48
    },
    {
        label: "5",
        value: 60
    },
    {
        label: "7",
        value: 84
    }
];

export const DEFAULT_REPAYMENT_TENURE = {
    "WEEKLY": 52,
    "MONTHLY": 12,
    "FORTNIGHTLY": 26
};

export const SALE_META_TYPE = {
    LISTING: "listingMeta",
    HOMESTRIP: "stripMeta"
};

export const DOWNLOAD_APP_URL = "";
export const DOWNLOAD_APP_URL_FOOTER = "https://cars24aus.app.link/CARS24AppDownload";

export const WEB_2_APP_BANNER = "WEB_2_APP_BANNER";

export const MOBILE_OS = {
    IOS: "iOS",
    ANDROID: "Android"
};

export const WEB_SOURCE = {
    msite: "mSite",
    desktop: "Desktop"
};

export const COUPON_STATUS = {
    SUCCESS: "SUCCESS",
    FAILED: "FAILED"
};

export const EXTENDEDWARRANTY = "extendedWarranty";

export const SPECIALPAGETYPE = {
    COMMON: "COMMON",
    LOCATION_BASED: "LOCATION_BASED"
};

export const LISTING_CONFIG = {
    [SPECIALPAGETYPE.COMMON]: {
        IS_META_ENABLED: true,
        IS_SEARCH_ENABLED: true,
        IS_FILTER_ENABLED: true,
        IS_COACHMARK_ENABLED: true,
        COMPONENT: "CarList"
    },
    [SPECIALPAGETYPE.LOCATION_BASED]: {
        IS_META_ENABLED: false,
        IS_SEARCH_ENABLED: true,
        IS_FILTER_ENABLED: false,
        IS_COACHMARK_ENABLED: false,
        COMPONENT: "CarList"
    }
};

export const UP_ARROW_ROTATE_DEGREE = 90;
export const DOWN_ARROW_ROTATE_DEGREE = -90;

export const AU_STATES_CODE = {
    NSW: "NSW",
    VIC: "VIC",
    SA: "SA",
    QLD: "QLD"
};

export const GEO_LOCATION_STATE_CODES = {
    [AU_STATES_CODE.VIC]: "Victoria",
    [AU_STATES_CODE.QLD]: "Queensland",
    [AU_STATES_CODE.NSW]: "New South Wales"
};

export const ORDER_TYPE = {
    TEST_DRIVE: "TEST_DRIVE",
    BUY_ONLINE: "BUY_ONLINE",
    PRODUCT_TEST_DRIVE: "PRODUCT_TEST_DRIVE",
    CAR_HISTORY_REPORT: "CAR_HISTORY_REPORT"
};

export const CAR_COMPARE_CONST = {
    STORAGE_KEY: "CAR_COMPARE_BUCKET",    //  storage key for car compare CLP
    STORAGE_KEY_CDP: "CAR_COMPARE_BUCKET_CDP", // storage key for car compare CDP
    ACTIVATION_KEY: "CAR_COMPARE_ACTIVE",   //  feature is inactive/active CLP
    SECONDARY_STORAGE_KEY: "CAR_COMPARE_SECONDARY_BUCKET",  // this bucket is used to activate feature if user views CDP >= 2 on CLP
    MAX_CARS_COUNT: NUMBER.TWO,    // max no of cars that can be compared on CLP
    CARS_COUNT_CDP_DESKTOP: NUMBER.THREE,  // no of cars required to compare on CDP dweb
    CARS_COUNT_CDP_MSITE: NUMBER.TWO,  // no of cars required to compare on CDP msite
    INITIAL_FIELDS_SHOWN: NUMBER.SEVEN // no of  fields shown to user initially
};

export const CTA_POSITION = {
    TOP: "top",
    BOTTOM: "bottom"
};

export const BANNER_TYPE = {
    FINANCE_BANNER: "FINANCE_BANNER"
};

export const LANDING_ROUTE_CONSTANTS = {
    "FINANCEYOURCAR": "/finance-your-car",
    "SELLYOURCAR": "/sell-my-car",
    "DEFAULT": "/",
    "FINANCE": "/cars24-finance"
};

export const C2B_ROUTES = [
    "/sell-my-car",
    "/car-valuation",
    "/my-sell-orders",
    "/book-inspection",
    "/price/communication"
];

export const EXCLUDING_GOVT_CHARGES = "Vehicle price";
export const DRIVE_AWAY_PRICE = "Drive-away price";

export const REFERRER_SOURCE = "referrerSource";

export const WARRANTY_FINANCE = "warranty_finance";
export const FILTER_ENTITIES = {
    BODY_TYPE: "bodyType",
    PRICE: "quotedPrice",
    FUEL_TYPE: "fuelType",
    OWNERS: "ownerNumber",
    ODOMETER_READING: "odometerReading",
    TRANSMISSION: "transmissionType",
    REGISTRATION_CITY: "registrationCity",
    YEAR: "year",
    MAKE: "make",
    MAKE_DISCOUNT: "makeDiscount",
    MODEL: "model",
    COLOR: "colorCategory",
    DISCOUNT: "promo",
    DOWNPAYMENT: "downPayment",
    MONTHLY_EMI: "monthlyEmi",
    DOORS: "doors",
    SEATS: "seats",
    DRIVETYPE: "driveType",
    HUB: "hub",
    LIFE_STYLE: "lifestyle",
    DELIVERYTIME: "deliveryTime",
    PROMOTION: "promotion",
    SAFETYANDQUALITY: "ancapRating",
    MAKECITYNAME: "makeCityName",
    MODELCITYNAME: "modelCityName",
    CITYNAME: "cityName",
    TEST_DRIVE: "testDrive",
    EMI_PER_WEEK: "emiPerWeek",
    DEPOSIT: "deposit",
    BUDGET_RANGE: "budgetRange",
    GREAT_DEALS: "greatDeals",
    CAR_TOUR: "carTour",
    SELLER_TYPE: "sellerType",
    DISTANCE: "distance",
    GEO_LOCATION: "geoLocation"
};

export const AU_RECENTLY_VIEWD_KEY = "au_rv";
export const AU_RECENTLY_VIEWD_TIMESTAMP = "au_rv_timestamp";
export const AU_RECENTLY_VIEWD_COUNT = "au_rv_count";

export const EXTENDED_WARRANTY_OPTED_PAGE = {
    CAR_COVER: "CAR_COVER",
    ORDER_SUMMARY: "ORDER_SUMMARY"
};

export const GALLERY_TAB_TYPE = {
    exterior: "exterior",
    interior: "interior",
    allImages: "allImages",
    imperfections: "imperfections",
    threeSixtyView: "threeSixtyView",
    threeSixtyViewUrl: "threeSixtyViewUrl",
    gallery: "gallery",
    videoGallery: "videoGallery",
    highlights: "highlights"
};

export const TRADE_IN_REJECTION_TYPE = {
    HIGH_VALUATION: "HIGH_VALUATION",
    HARD_REJECTION: "HARD_REJECTION"
};

export const ENABLE_MINIMUM_SPLIT_PAY = "enableMinimumSplitPay";
export const DAP_CALLOUT_VIEWD = "dapCalloutViewd";

export const CALLBACK_SOURCE_SCREEN = {
    LOAN_OFFERS: "LOAN_OFFERS",
    LENDER_DETAILS: "LENDER_DETAILS",
    PAYMENT_DETAILS: "PAYMENT_DETAILS",
    TEST_DRIVE_CONFIRMATION: "TEST_DRIVE_CONFIRMATION",
    DAP_MODAL: "DAP_MODAL"
};
export const DELIVERY_TIMELINE_MAPPING = {
    Queensland: {
        code: "QLD",
        pincode: 4000,
        fullStateName: "Queensland"
    },
    Victoria: {
        code: "VIC",
        pincode: 3000,
        fullStateName: "Victoria"

    },
    Newsouthwales: {
        code: "NSW",
        pincode: 2000,
        fullStateName: "New South Wales"
    },
    "New South Wales": {
        code: "NSW",
        pincode: 2000,
        fullStateName: "New South Wales"
    }
};

export const SET_DELIVERY_TIMELINE = "SET_DELIVERY_TIMELINE";

export const POST_JOURNEY_STEPS_TYPE = {
    POST_PAYMENT_JOURNEY: "postPaymentJourney",
    TASK_JOURNEY: "taskJourney",
    ST_TASK_JOURNEY: "stTaskJourney",
    GUEST_POST_PAYMENT_JOURNEY: "guestPostPaymentJourney"
};

export const BANK_TRANSFER = [
    {
        label: "Name",
        value: "GLOBAL CARS AUS PTY LTD",
        eventLabel: "WTName",
        key: "bankAccountName",
        amplitudeKey: "WT Name copied",
        amplitudeEvtProperty: { "BT Name copied": "yes" }
    },
    {
        label: "Account number",
        value: "850046",
        eventLabel: "WTAccNo",
        key: "bankAccountNumber",
        amplitudeKey: "WT AccNo copied",
        amplitudeEvtProperty: { "BT Accno copied": "yes" }
    },
    {
        label: "BSB",
        value: "032 044",
        eventLabel: "WT BSB",
        key: "bsb",
        amplitudeKey: "WT BSB copied",
        amplitudeEvtProperty: { "BT BSB copied": "yes" }
    },
    {
        label: "Reference",
        value: "",
        eventLabel: "WT reference",
        key: "reference",
        amplitudeKey: "WT reference copied",
        amplitudeEvtProperty: { "BT reference copied": "yes" }
    },
    {
        label: "Amount",
        value: "",
        eventLabel: "WT Amount",
        key: "bookingAmount",
        amplitudeKey: "WT Amount copied",
        amplitudeEvtProperty: { "BT amount copied": "yes" }
    }
];

export const USER_LOGIN_STATUS = {
    LOGGED_IN: "loggedin",
    LOGGED_OUT: "loggedout"
};
export const USER_LOGIN_MEDIUM = {
    EMAIL: "email",
    PHONE: "phone",
    GOOGLE: "google",
    FACEBOOK: "facebook",
    APPLE: "apple"
};
export const LISTING_TYPE = {
    ALL_CARS: "all_cars",
    SEARCH: "search_list"
};
export const SALE_KEY = {
    BLACK_FRIDAY: "BLACK_FRIDAY",
    CHRISTMAS_SALE: "CHRISTMAS_SALE",
    EOFY_SALE: "EOFY_SALE"
};
export const USER_GUEST_EMAIL = "USER_GUEST_EMAIL";
export const SHOW_GUEST_EXIT_INTENT = "SHOW_GUEST_EXIT_INTENT";

export const PAYMENT_SUCCESS_TEXT = { // move this
    DRIVA: "FINANCE",
    BYOF: "FINANCE",
    CARS24: "FINANCE",
    NONE: "NONE",
    BT: "BT",
    ZERO_DP: "ZERO_DP"
};

export const SMS_CHAT_NUMBER = { label: "+61 482 075 273", value: "+61482075273" };
export const C2B_SMS_CHAT_NUMBER = { label: "+61 482 091 942", value: "61482091942" };
export const AU_CONTACT_TELEPHONE = "+61482091942";

export const WHATS_APP_MESSAGE = {
    WEB: "Hey Cars24 AU, I need help",
    MSITE: "I am looking for an assistance"
};
export const FB_EVENTS_CATEGORY = {
    HOME_PAGE_MAKE: "homepage_make",
    HOME_PAGE_MAKE_MODEL: "homepage_make_model",
    LISTING_PAGE_MAKE: "listing_make",
    LISTING_PAGE_MAKE_MODEL: "homepage_make_model",
    SEARCH_SUGGESTIONS: "search_suggestions"
};

export const SELL_CAR_SEO_MENU = [ //move this
    {
        label: "Sell my car in Brisbane",
        spath: "sell-my-car-brisbane/"
    },
    {
        label: "Sell my car in Melbourne",
        spath: "sell-my-car-melbourne/"
    },
    {
        label: "Sell my car in Sydney",
        spath: "sell-my-car-sydney/"
    },
    {
        label: "Sell my car in Melton",
        spath: "sell-my-car-melton/"
    },
    {
        label: "Sell my car in Dandenong",
        spath: "sell-my-car-dandenong/"
    },
    {
        label: "Sell My Car in Newcastle",
        spath: "sell-my-car-newcastle/"
    },
    {
        label: "Sell My Car in Central Coast",
        spath: "sell-my-car-centralcoast/"
    },
    {
        label: "Sell My Car in Geelong",
        spath: "sell-my-car-geelong/"
    },
    {
        label: "Used Car Valuation",
        spath: "sell-my-car/car-valuation/"
    }
];

export const TRADE_IN_EXPIRED = {
    APPLY_AGAIN: "APPLY_AGAIN"
};

export const TRADE_IN_UI = {
    INTRO: "INTRO",
    RESUME_VALUATION: "RESUME_VALUATION",
    EDIT_DETAILS: "EDIT_DETAILS",
    TRADE_IN_EXPIRED: "TRADE_IN_EXPIRED",
    WRITTEN_OFF: "WRITTEN_OFF"
};

export const CDP_REVIEW_LINK = {
    google_review: "https://www.google.com/maps/place/CARS24+Australia/@-32.7153521,148.955806,6z/data=!4m6!3m5!1s0x6ad64304dde9db3d:0xdcbe0bace6f08656!8m2!3d-32.7153521!4d148.955806!16s%2Fg%2F11nghy02c_",
    trust_pilot: "https://au.trustpilot.com/review/cars24.com/au",
    product_review: "https://www.productreview.com.au/listings/cars24-australia"
};

export const PAGE_SOURCE = {
    CLP: "clp",
    CDP: "cdp",
    CDP_SIMILAR_CARS: "cdp - similar cars",
    HOME_PAGE: "homepage",
    WISHLIST: "wishlist",
    FINANCE_LANDING_PAGE: "finance_landing_page",
    SELL_VALUATION_PAGE: "sell_valuation_page",
    SELL: "C2B_flow",
    CAR_VALUATION_CALCULATOR: "car_valuation_calculator",
    POST_BC_FLOW: "post_bc_flow",
    CLP_LOAN_CALCULATOR: "clp_loan_calculator",
    FINANCE_CLP: "finance_clp",
    ROADWORTHY_CERTIFICATE: "roadworthy_certificate",
    SELL_PAGE: "sell_page",
    THREE_HUNDERED_POINT_INSPECTION: "300_point_inspection",
    RWC: "RWC",
    VIDEO_GALLERY: "video_gallery",
    CAR_HISTORY_REPORT: "car_history_report",
    BOOK_INSPECTION_CONFIRMATION: "book_inspection_confirmation",
    TEST_DRIVE_BOOKED: "td_booked_page",
    SELL_VALUATION_PAGE_AUTOGRAB: "sell_valuation_page_autograb",
    SELL_INSPECTION_BOOKED_PAGE: "sell_inspection_booked_page",
    CAR_HISTORY_REPORT_TERMS_OF_PURCHASE: "car_history_report_terms_of_purchase",
    PRIVACY_POLICY_STATEMENT: "privacy_policy_statement",
    DEALER_LANDING_PAGE: "dealer_landing_page"
};
export const BOTTOM_NAV_ROUTES = {
    HOME: "au.home",
    LISTING: "au.listing",
    SELL_CAR: "c2b-trade",
    FINANCE_PAGE: "finance"
};

export const GA_EVENT_CATEGORY = {
    [PAGE_SOURCE.CLP]: "Cars24_listing_page",
    [PAGE_SOURCE.CDP]: "Cars24_detail_page",
    [PAGE_SOURCE.HOME_PAGE]: "Cars24_home_page",
    [PAGE_SOURCE.SELL]: "C2B_flow"
};

export const BOOL_STRING = {
    TRUE: "true",
    FALSE: "false"
};

export const SIMILAR_CAR_HEADING = "Similar cars you may like";
export const HTTP_API_ERROR = "HTTP_API_ERROR";
export const MODEL_YEAR = "Model Year";
export const BOOTSPACELABEL = "Boot Inside View with Luggage";
export const FILTER_TYPES = {
    RANGE_FILTER: "rf",
    STRING_FILTER: "sf"
};

export const SOCIAL_MEDIA_DATA = [
    {
        link: "https://www.instagram.com/cars24au/",
        title: "Instagram"
    },
    {
        link: "https://www.facebook.com/CARS24Australia/",
        title: "Facebook"
    },
    {
        link: "https://www.linkedin.com/company/cars24-australia/",
        title: "LinkedIn"
    },
    {
        link: "https://twitter.com/cars24au",
        title: "Twitter"
    },
    {
        link: "https://www.youtube.com/@cars24au",
        title: "YouTube"
    }
];

export const FOOTER_GEOS = [
    {
        link: "https://www.cars24.com/",
        title: "India"
    },
    {
        link: "https://www.cars24.ae/",
        title: "UAE"
    }
];

export const FINANCE_TNC_LINK = "https://drive.google.com/file/d/1F0bWk5o1KoG8kyRZ120nhGLePuISAvQq/view";

export const API_PROMISE_REJECTED = { //move
    CLP_RESPONSE_REJECTED: "SSR ERROR in getCarListing AU PROMISE REJECTED",
    CLP_DATA_RESPONSE_REJECTED: "SSR ERROR in getClpData AU PROMISE REJECTED"
};

export const CALCULATOR_CONSTANTS = {
    PRINCIPAL: "principal",
    DEPOSIT: "deposit",
    RATE: "rate"
};

export const FINANCE_METADATA_SCENARIO = {
    APPROVED_AND_NON_BI: "Approved_And_Non_Bi",
    NON_APPROVED_AND_NON_BI: "Non_Approved_And_Non_Bi"
};
export const RECENTLY_VIEWED = "recentlyViewed";
export const PICKS_FOR_YOU = "picksForYou";
export const WISHLIST_CAR = "wishlistedCar";
export const TASK_SOURCES = {
    IN_HOUSE_FINANCE: "IN_HOUSE_FINANCE",
    DOC_SIGN: "DOC_SIGN",
    DMS: "DMS"
};

export const TASK_SOURCES_ALERT = {
    FINISH_LOAN_APPLICATION: "FINISH_LOAN_APPLICATION",
    UPLOAD_DOCUMENTS: "UPLOAD_DOCUMENTS",
    DL_VERIFY: "DL_VERIFY",
    SALE: "SALE",
    SPLIT_PAYMENT: "SPLIT_PAYMENT"
};

export const ENABLE_NEW_POST_BOOK_FLOW = {
    UPLOAD_DOCUMENTS: "UPLOAD_DOCUMENTS",
    DL_VERIFY: "DL_VERIFY",
    SPLIT_PAYMENT: "SPLIT_PAYMENT",
    SALE: "SALE"
};

export const STEP_ROUTE_MAP = {
    SELECT_CAR_INFO: "car-details",
    VALUATION: "valuation",
    CAR_CONDITION: "exterior-condition",
    PRECONDITIONS: "pre-conditions",
    EXTERIOR_CONDITION: "exterior-condition",
    MECHANICAL_CONDITION: "mechanical-condition",
    INTERIOR_CONDITION: "interior-condition",
    CAR_CONDITION_AND_DETAILS: "exterior-condition",
    ESTIMATED_VALUATION: "estimated-valuation",
    ADDITIONAL_DETAILS: "extra-details"
};

export const INSPECTION_ROUTE_MAP = {
    SELECT_DAY: "select-day",
    PERSONAL_DETAILS: "personal-details"
};

export const SEARCH_ALL_CARS_ROUTE = `/buy-used-cars-${COUNTRY.slug}`;

export const EQUIFAX_OUTAGE = 1017;
export const NO_CREDIT_SCORE_FOUND = 1006;
export const EXTENDED_WARRANTY_DURATION = {
    MIN: 16,
    MAX: 33
};

export const SWIPE_EVENT_FIRED = "SWIPE_EVENT_FIRED";

export const CURRENT_SALE = "SALE";

export const TEST_DRIVE_FINANCE_OPTIONS = {
    TD__FINANCE: "TD__FINANCE",
    TD__CASH: "TD__CASH",
    TD__BYO: "TD__BYO"
};

export const LOAN_QUOTES_SOURCE = {
    DEFAULT_CHECKOUT: "default",
    TEST_DRIVE_FLOW: "test_drive"
};

export const FINANCE_CENTRIC_CONSTANTS = {
    QUERY_PARAM: "fc",
    DEFAULT_CLP: "DEFAULT_CLP",
    FINANCE_CENTRIC_CLP: "FINANCE_CENTRIC_CLP",
    REDIRECT_TO_FINANCE_CENTRIC_CLP: "REDIRECT_TO_FINANCE_CENTRIC_CLP",
    REDIRECT_TO_DEFAULT_CLP: "REDIRECT_TO_DEFAULT_CLP",
    FINANCE_CENTRIC_MODAL: "FINANCE_CENTRIC_MODAL"
};
export const MAXIMUM_REPAYMENT = NUMBER.NINE_NINETY_NINE;

export const VAS_PAGE_SCREEN_TYPE = {
    CAR_COVER: "CAR24_COVER",
    ADD_ONS: "ADD_ONS"
};

export const INVENTORY_CAR_CARD_LABELS = {
    RESERVED: "reserved",
    VIEWED: "viewed",
    SOLD: "sold",
    DISCOUNT: "discount",
    NEW: "new",
    PRICE_DROP: "priceDrop",
    COMING_SOON: "comingSoon",
    DEALER: "dealer"
};

export const ACQUISITION_TYPE = {
    SELF_BOOKING_LINK: "SELF_BOOKING_LINK"
};

export const WEBSITE_SECTIONS = {
    FINANCE_FIRST_FLOW: "finance_first_flow",
    FINANCE_FIRST_DISCOVERY: "finance_first_discovery"
};

export const SERVICING_VARIANT_MAPPING = {
    CONTROL: "OLD",
    VARIANT: "TESTING"
};

export const FINANCE_STEPS = [
    "We will reach out to you to schedule an inspection for your car.",
    "The proposed trade-in value will be adjusted in your loan amount."
];
export const CASH_STEPS = [
    "We will reach out to you to schedule an inspection for your car.",
    "The proposed trade-in value will be adjusted in your contract."
];
export const VERIFY_LICENCE_SCREEN_TYPES = {
    INTRO: "INTRO",
    UPLOAD_FORM: "UPLOAD_FORM",
    UPLOAD_CONFIRMATION: "UPLOAD_CONFIRMATION"
};

export const HISTORY_SOURCE_CONSTANTS = {
    SIMILAR_CARS: "similarCars"
};

// Added constants from AU C2B file

export const TEST_DRIVE_BOOKING_STATUS_MESSAGE = {
    BOOKED: "Test drive booked",
    COMPLETED: "Test drive conducted",
    CANCELLED: "Test drive has been cancelled",
    RESCHEDULED: "",
    CANCELLING: ""
};

export const TEST_DRIVE_BOOKING_STATUS_TYPE = {
    BOOKED: "BOOKED",
    COMPLETED: "COMPLETED",
    CANCELLED: "CANCELLED",
    RESCHEDULED: "RESCHEDULED",
    CANCELLING: "CANCELLING"
};

export const APPOINTMENT_SCREEN = {
    DEFAULT: "default",
    ADDRESS: "address",
    DOCUMENT: "document"
};

export const ERROR_TYPES = {
    DEFAULT: "default",
    ODOMETER: "odometer",
    YEAR: "year",
    FINANCE: "finance",
    HIGH_VALUATION: "highValuation",
    CONDITION: "condition",
    DO_NOT_PROCURE: "doNotProcure",
    MAKE_MODEL_ERROR: "makeModelError",
    WRITTEN_OFF: "writtenOff",
    REGISTRATION: "registration"
};

export const ERROR_STATUS_MAP = {
    1013: ERROR_TYPES.DEFAULT,
    1020: ERROR_TYPES.ODOMETER,
    1021: ERROR_TYPES.YEAR,
    1022: ERROR_TYPES.FINANCE,
    1025: ERROR_TYPES.HIGH_VALUATION,
    1027: ERROR_TYPES.CONDITION,
    1028: ERROR_TYPES.DO_NOT_PROCURE,
    1030: ERROR_TYPES.MAKE_MODEL_ERROR
};

export const KBB_MMVY_ERROR_CODE = 1033;
export const KBB_REGO_VIN_ERROR_CODE = 1034;

export const ERROR_GA_MAP = {
    [ERROR_TYPES.DEFAULT]: "default_rejection",
    [ERROR_TYPES.ODOMETER]: "odo_rejection",
    [ERROR_TYPES.YEAR]: "year_rejection",
    [ERROR_TYPES.FINANCE]: "finance_rejection",
    [ERROR_TYPES.HIGH_VALUATION]: "price_rejection",
    [ERROR_TYPES.CONDITION]: "condition_rejection",
    [ERROR_TYPES.DO_NOT_PROCURE]: "do_not_procure_rejection",
    [ERROR_TYPES.MAKE_MODEL_ERROR]: "make_model_rejection",
    [ERROR_TYPES.WRITTEN_OFF]: "written_off",
    [ERROR_TYPES.REGISTRATION]: "registration"
};

export const CITY_WISE_CONTENT = {
    Brisbane: {
        top: {
            heading: "Sell used cars in Brisbane, 100% online",
            description: "Selling your car can be exhausting and stressful. No more wasting your time listing your car in every online marketplace and classifieds. No more waiting for calls and emails from 'potential buyers' who never respond and often never show up to inspect. No more questions from buyers who aren't serious about purchasing. Sell your car to Cars24 in Melbourne today, all online."
        },
        bottom: {
            heading: "How Cars24 decides the best price for your car",
            description: "When you sell your car with us, you can use our free car valuation calculator to find out how much your car is worth. To get an estimate, enter details such as your car model, make, mileage, physical condition, number of keys, damage, and imperfections. Cars24 provides a sophisticated tool for used car valuation to offer an estimate of your car's market value, which you can then use to compare rates at car dealers. It helps you determine the trade-in value for your car and answers your question of 'What is the trade-in value for my car?'. Whether you want to sell your car in Australia or find cars for cash near you, Cars24 is a great choice to find car buyers online and for those looking to trade in their current car in lieu of buying the next one.",
            additionalText: ""
        },
        reviews: [{
            name: "Francesca K.",
            title: "Easy and quick sale…",
            description: "Easy and quick sale… would definitely recommend selling this way. I sold my car through Cars24 (I am based in Brisbane). The whole process was so easy and I am very happy with their offer for my car. Sagar (the Cars24 rep) kept me in the loop throughout, and everything was processed so quickly. A deal was agreed on, on the day of the inspection. A deposit was paid immediately, and the balance was deposited into my account the day before they collected the car. I am really impressed and would definitely recommend this method of selling a car to my friends. Do yourself a favour and don't waste time haggling with people on selling sites. Thanks, Sagar for helping make the process so easy"
        },
        {
            name: "Michael Ward",
            title: "Sale of my 2016 Toyota Hilux Ute",
            description: "Sale of my 2016 Toyota Hilux Ute. Thank you Cars24 team for doing a fantastic job buying my car. I got the price I wanted and the process was seamless which I appreciate greatly. Kindest regards"
        },
        {
            name: "Ashlee",
            title: "Super easy hassle free!",
            description: "Super easy hassle free! Sold my car for a reasonable price, Cars24 handled all the logistics with zero hassle. Divya was very helpful and friendly. Would definitely use it again."
        }
        ],
        location: [
            {
                text: "40 Steel Pl, Morningside QLD 4170"
            }
        ]
    },
    Melbourne: {
        top: {
            heading: "Sell used cars in Melbourne, 100% online",
            description: "Selling your car can be exhausting and stressful. No more wasting your time listing your car in every online marketplace and classifieds. No more waiting for calls and emails from 'potential buyers' who never respond and often never show up to inspect. No more questions from buyers who aren't serious about purchasing. Sell your car to Cars24 in Melbourne today, all online."
        },
        bottom: {
            heading: "How Cars24 decides the best price for your car",
            description: "When you sell your car with us, you can use our free car valuation calculator to find out how much your car is worth. To get an estimate, enter details such as your car model, make, mileage, physical condition, number of keys, damage, and imperfections. Cars24 provides a sophisticated tool for used car valuation to offer an estimate of your car's market value, which you can then use to compare rates at car dealers. It helps you determine the trade-in value for your car and answers your question of 'What is the trade-in value for my car?'. Whether you want to sell your car in Australia or find cars for cash near you, Cars24 is a great choice to find car buyers online and for those looking to trade in their current car in lieu of buying the next one.",
            additionalText: ""
        },
        reviews: [{
            name: "Alison G",
            title: "Selling my car to Cars24 was so easy!!",
            description: "Selling my car to Cars24 was so easy!! The whole experience of selling my car to Cars24 was very easy. I inquired about selling my car and that day Vish called me and organised a virtual inspection. This was done over video call. That afternoon he had already sent me the contract of sale and the next day the money was transferred into my bank account. The car was picked up the following day. So well organised and easy!"
        },
        {
            name: "Olivia",
            title: "So easy, I didn't have to do a thing!",
            description: "So easy, I didn't have to do a thing! Selling my car via Cars24 was so easy. I supplied a few details, answered some simple questions and they made me a competitive offer in no time. No haggling, no time wasters and no stress for me. The whole process was made easier as I didn't need to do a thing - I didn't even have to wash the car! Hassle free for me , I'd definitely recommend selling via Cars24."
        },
        {
            name: "Suzana Anna Djordj",
            title: "Thank You Cars24!!",
            description: " Selling my Toyota Corolla was simply amazing, Thank You Cars24!! Thank you Noreen!! First time user of Cars24 and all I can say is, it's absolutely the best way to sell a car. From start to finish the process was so easy, no stress, no headaches, Ms Noreen was simply wonderful, very patient with me, very professional and explained the process thoroughly.  I can honestly say I recommend this service 110% to everyone who has a car to sell. Thank you again Ms Noreen, I've not had such outstanding customer service in a while!!"
        }
        ],
        location: [
            {
                text: "118 Cherry Ln, Laverton North VIC 3026"
            }
        ]

    },
    Sydney: {
        top: {
            heading: "Sell used cars in Sydney, 100% online",
            description: "Selling your car can be exhausting and stressful. No more wasting your time listing your car in every online marketplace and classifieds. No more waiting for calls and emails from 'potential buyers' who never respond and often never show up to inspect. No more questions from buyers who aren't serious about purchasing. Sell your car to Cars24 in Melbourne today, all online."
        },
        bottom: {
            heading: "How Cars24 decides the best price for your car",
            description: "When you sell your car with us, you can use our free car valuation calculator to find out how much your car is worth. To get an estimate, enter details such as your car model, make, mileage, physical condition, number of keys, damage, and imperfections. Cars24 provides a sophisticated tool for used car valuation to offer an estimate of your car's market value, which you can then use to compare rates at car dealers. It helps you determine the trade-in value for your car and answers your question of 'What is the trade-in value for my car?'. Whether you want to sell your car in Australia or find cars for cash near you, Cars24 is a great choice to find car buyers online and for those looking to trade in their current car in lieu of buying the next one.",
            additionalText: ""
        },
        reviews: [{
            name: "Timothy",
            title: "Easy, hassle free process!",
            description: "Easy, hassle free process! The process of selling my car happened in a matter of days. Noreen, who accompanied the process, exceeded my expectations. Overall satisfied with the service!"
        },
        {
            name: "Fernando Jose Belchior dos Santos",
            title: "Sale of my 2016 Toyota Hilux Ute",
            description: " I really liked all the work done by Cars24. From the valuation to vehicle pick-up everything was smooth and hassle free."
        },
        {
            name: "Bennette",
            title: "Reliable, fast and simple",
            description: "I feel it very simple and fast, reliable, especially with the communication with Miss Noreen, she shows her profession, patience to answer my lots of questions as its my first time selling car through online. if my friends would like to buy and sell the car, I could recommend cars24 to them."
        }
        ],
        location: [
            {
                text: "155 Parramatta Rd, Granville NSW 2142"
            }
        ]
    },
    default: {
        reviews: [{
            name: "Glenn",
            title: "Incredibly easy to sell",
            description: "Incredibly easy to sell. Gave me the best price out of any quotes I had received, and the sales process could not have been quicker or simpler. Massive kudos to this company and for Connor who assisted. Dream transaction!"
        },
        {
            name: "Rachelle",
            title: "I sold my car in a matter of days!",
            description: " I sold my car in a matter of days! I can't believe how easy the whole process was. Virtual inspection was organised for the next day following the initial contact. I was offered a good price then and there. Deposit transferred immediately and pick up organised, full balance received the day before pick up. I only had to sign and hand over the keys! The best part of all of this was I didn't have to worry about strangers coming to look at the car, haggling prices and taking time out of my day to sell my car. The easiest and most stress free process, extremely happy with Cars24!"
        },
        {
            name: "Hannah T",
            title: "Great, simple process",
            description: "Really easy process. Great, simple process. My car was sold very quickly- the virtual inspection was easy and the lady talked me through exactly what I needed to do. An offer was made immediately and payment came through promptly. Seamless process. One which I'd do again for sure!"
        }
        ],
        location: [
            {
                text: "<span>Melbourne:</span> 118 Cherry Ln, Laverton North VIC 3026"
            },
            {
                text: "<span>Brisbane:</span> 40 Steel Pl, Morningside QLD 4170"
            },
            {
                text: "<span>Sydney:</span> 155 Parramatta Rd, Granville NSW 2142"
            }
        ]
    }
};

export const SHAZAM_FAQ = {
    key: "shazamFaq",
    heading: "How can I enter the SHAZAM! FURY OF THE GODS offer? ",
    data: ["Entry is only open to NSW, QLD and VIC residents who are 18 years and over and holds a valid drivers licence issued in an Australian State or Territory AND be the registered owner of the vehicle submitted for valuation."],
    listPoints: [
        "All completed valuations 1-16th March will automatically enter the prize draw to WIN 1 of 10 double cinema passes to see 'Shazam! Fury of the Gods'.",
        "All completed valuations 1-31st March will automatically enter the prize draw to WIN a used Mini Cooper S 2014 with automatic transmission, including a minimum of 3-months registration, a minimum 3-months compulsory third party insurance, stamp duty and dealer delivery charges (which may vary from State by State)."
    ]
};

export const GUEST_POPUP_TYPES = {
    EMAIL: "email",
    VERIFY: "verify"
};

export const OPTIONS_LIST_TYPE = {
    LIST: "list",
    POPULAR: "popular"
};

export const UTM_PARAMS_KEY = "utm__params";

export const TRADE_STATE = [
    {
        stateCode: "AU_VIC",
        stateName: "Victoria",
        label: "VIC",
        value: "Victoria"
    },
    {
        stateCode: "AU_NSW ",
        stateName: "New South Wales",
        label: "NSW",
        value: "New South Wales"
    },
    {
        stateCode: "AU_QLD",
        stateName: "Queensland",
        label: "QLD",
        value: "Queensland"
    },
    {
        stateCode: "AU_SAU",
        stateName: "South Australia",
        label: "SA",
        value: "South Australia"
    },
    {
        stateCode: "AU_CAPTR",
        stateName: "Australian Capital Territory",
        label: "ACT",
        value: "Australian Capital Territory"
    },
    {
        stateCode: "AU_WEST",
        stateName: "Western Australia",
        label: "WA",
        value: "Western Australia"
    },
    {
        stateCode: "AU_TAS",
        stateName: "Tasmania",
        label: "TAS",
        value: "Tasmania"
    },
    {
        stateCode: "AU_NTR",
        stateName: "Northern Territory",
        label: "NT",
        value: "Northern Territory"
    }
];

export const BREADCRUMB_DATA = [
    {
        label: "Home",
        path: "/"
    },
    {
        label: "Sell my car",
        path: "/sell-my-car/"
    }
];

export const LOGIN_SOURCE = {
    WISHLIST: "wishlist",
    FINANCE: "finance",
    TRADE_IN: "tradein",
    CHECKOUT: "checkout",
    HAMBURGER: "hamburger",
    CLASSISFIEDS: "classifieds",
    COMING_SOON: "coming soon"
};

export const CDP_REDIRECTION_KEY = "c2b_cdp_redirection";

export const FOOTER_TEXT_KEYS = {
    PRICE_DROP: "PRICE_DROP",
    WISHLISTED: "WISHLISTED",
    VIEWED: "VIEWED"
};

export const getConvenienceFeeBreakup = (financeOwning) => ([
    {
        title: "Admin & Paperwork",
        description: "We handle the preparation of contracts, ID verification, and other documentation"
    },
    {
        title: "Registration Transfer Handling",
        description: "We manage the complete registration transfer process"
    },
    ...(financeOwning === "Yes" ? [{
        title: "Finance Settlement Assistance",
        description: "We manage the payout process with your lender to clear any outstanding finance"
    }] : []),
    {
        title: "Vehicle Verification",
        description: "We conduct a PPSR check and car history verification to ensure the vehicle’s details are accurate"
    }
]);

export const WEB_VIEW_CONSTANTS = {
    HIDE_APP_HEADER: "HIDE_APP_HEADER",
    SHOW_APP_HEADER: "SHOW_APP_HEADER",
    EXIT_WEBVIEW: "EXIT_WEBVIEW",
    CHR_TERMS_OF_PURCHASE_REDIRECT: "CHR_TERMS_OF_PURCHASE_REDIRECT",
    PRIVACY_POLICY_REDIRECT: "PRIVACY_POLICY_REDIRECT",
    DOWNLOAD_FILE: "DOWNLOAD_FILE"
};

export const BLACKLISTED_WEBVIEW_LAYOUT_PAGES = [
    PAGE_SOURCE.CAR_HISTORY_REPORT,
    PAGE_SOURCE.CAR_HISTORY_REPORT_TERMS_OF_PURCHASE,
    PAGE_SOURCE.PRIVACY_POLICY_STATEMENT,
    PAGE_SOURCE.DEALER_LANDING_PAGE
];

export const FILTER_KEYS = {
    // CLASSIFIEDS: "CLASSIFIEDS",
    // CARS24: "CARS24" */
    CLASSIFIEDS: "CLASSIFIEDS",
    CARS24: "CARS24",
    CARS24_SELECT: "CARS24_SELECT",
    CARS24_LUXE: "CARS24_LUXE"
};

export const KBB_EXPIRY_LOADING_STATES = [
    "Fetching car details", "Hang on tight!"
];

export const LISTING_TYPE_BRANDING = {
    DEALER: DealerListing,
    INTERNAL: InternalListing
};

export const CLASSIFIED_BRANDING_CONSTANTS = {
    internal: {
        defaultLabel: "Cars24 Select",
        label: "Cars24 Select",
        logo: InternalListingLogo
    },
    dealer: {
        defaultLabel: "Dealer Listing",
        label: "Dealer Listing",
        logo: DealerListingLogo
    },
    luxury: {
        defaultLabel: "Cars24 Luxury",
        label: "Cars24 Luxury",
        logo: LuxuryIcon
    }
};

export const SELLER_TYPES = {
    LUXURY: "luxury",
    INTERNAL: "internal",
    DEALER: "dealer"
};

export const PLATFORMS = {
    DESKTOP: "desktop",
    MOBILE: "mobile"
};

export const STYLE_COMPONENTS = {
    BUY_WITH_CONFIDENCE_CARD: "buyWithConfidenceCard",
    INVENTORY_CAR_CARD: "inventoryCarCard",
    WHY_CHOOSE_THIS_CAR: "whyChooseThisCar",
    QUALITY_PROMISE: "qualityPromise",
    HOME: "home",
    CAR_DETAIL_ATF_HEADER: "carDetailAtfHeader",
    CDP_OVERVIEW: "cdpOverview"
};

export const STYLE_KEYS = {
    OUTER: "outer",
    OUTER_WITH_EXTRAS: "outerWithExtras",
    REVAMP_CAR_CARD: "revampCarCard",
    REVAMP_LOCATION_CONTAINER: "revampLocationContainer",
    REASONS_CONTAINER: "reasonsContainer",
    RIGHT_PANEL: "rightPanel",
    CONTAINER: "container",
    USED_CAR_WRAPPER: "usedCarWrapper",
    RECOMMENDED_WRAPPER: "recommendedWrapper",
    WRAPPER: "wrapper",
    CAR_BOTTOM_STRIP_WRAPPER: "carBottomStripWrapper",
    LISTING_LABEL: "listingLabel",
    OVERVIEW_WRAPPER: "overviewWrapper"
};

const SELLER_TYPE_STYLES = {
    [PLATFORMS.DESKTOP]: {
        [STYLE_COMPONENTS.BUY_WITH_CONFIDENCE_CARD]: {
            [STYLE_KEYS.OUTER]: {
                [SELLER_TYPES.LUXURY]: "styles.outerLuxury",
                [SELLER_TYPES.INTERNAL]: "styles.outer",
                [SELLER_TYPES.DEALER]: "styles.outer"
            },
            [STYLE_KEYS.OUTER_WITH_EXTRAS]: {
                [SELLER_TYPES.LUXURY]: "styles.outer styles.outer2 styles.outerLuxury",
                [SELLER_TYPES.INTERNAL]: "styles.outer styles.outer2",
                [SELLER_TYPES.DEALER]: "styles.outer styles.outer2"
            }
        },
        [STYLE_COMPONENTS.INVENTORY_CAR_CARD]: {
            [STYLE_KEYS.REVAMP_CAR_CARD]: {
                [SELLER_TYPES.LUXURY]: "styles.revampCarCardLuxury",
                [SELLER_TYPES.INTERNAL]: "styles.revampCarCard",
                [SELLER_TYPES.DEALER]: "styles.revampCarCard"
            },
            [STYLE_KEYS.REVAMP_LOCATION_CONTAINER]: {
                [SELLER_TYPES.LUXURY]: "styles.revampLocationContainerLuxury",
                [SELLER_TYPES.INTERNAL]: "styles.revampLocationContainer",
                [SELLER_TYPES.DEALER]: "styles.revampLocationContainer"
            }
        },
        [STYLE_COMPONENTS.WHY_CHOOSE_THIS_CAR]: {
            [STYLE_KEYS.REASONS_CONTAINER]: {
                [SELLER_TYPES.LUXURY]: "styles.reasonsContainerLuxury",
                [SELLER_TYPES.INTERNAL]: "styles.reasonsContainer",
                [SELLER_TYPES.DEALER]: "styles.reasonsContainer"
            }
        },
        [STYLE_COMPONENTS.QUALITY_PROMISE]: {
            [STYLE_KEYS.RIGHT_PANEL]: {
                [SELLER_TYPES.LUXURY]: "styles.rightPanelLuxury",
                [SELLER_TYPES.INTERNAL]: "styles.rightPanel",
                [SELLER_TYPES.DEALER]: "styles.rightPanel"
            },
            [STYLE_KEYS.CONTAINER]: {
                [SELLER_TYPES.LUXURY]: "styles.qualityPromiseContainerLuxury",
                [SELLER_TYPES.INTERNAL]: "styles.qualityPromiseContainer",
                [SELLER_TYPES.DEALER]: "styles.qualityPromiseContainer"
            }
        },
        [STYLE_COMPONENTS.HOME]: {
            [STYLE_KEYS.USED_CAR_WRAPPER]: {
                [SELLER_TYPES.LUXURY]: "styles.usedCarWrapperLuxury",
                [SELLER_TYPES.INTERNAL]: "styles.usedCarWrapper",
                [SELLER_TYPES.DEALER]: "styles.usedCarWrapper"
            },
            [STYLE_KEYS.RECOMMENDED_WRAPPER]: {
                [SELLER_TYPES.LUXURY]: "styles.recommendedWrapperLuxury",
                [SELLER_TYPES.INTERNAL]: "styles.recommendedWrapper",
                [SELLER_TYPES.DEALER]: "styles.recommendedWrapper"
            }
        },
        [STYLE_COMPONENTS.CAR_DETAIL_ATF_HEADER]: {
            [STYLE_KEYS.LISTING_LABEL]: {
                [SELLER_TYPES.LUXURY]: "styles.luxuryListingLabel",
                [SELLER_TYPES.INTERNAL]: "styles.internalListingLabel",
                [SELLER_TYPES.DEALER]: "styles.dealerListingLabel"
            }
        }
    },
    [PLATFORMS.MOBILE]: {
        [STYLE_COMPONENTS.BUY_WITH_CONFIDENCE_CARD]: {
            [STYLE_KEYS.OUTER]: {
                [SELLER_TYPES.LUXURY]: "styles.outer styles.luxuryNew",
                [SELLER_TYPES.INTERNAL]: "styles.outer",
                [SELLER_TYPES.DEALER]: "styles.outer"
            },
            [STYLE_KEYS.OUTER_WITH_EXTRAS]: {
                [SELLER_TYPES.LUXURY]: "styles.outer styles.outer2 styles.luxuryNew",
                [SELLER_TYPES.INTERNAL]: "styles.outer styles.outer2",
                [SELLER_TYPES.DEALER]: "styles.outer styles.outer2"
            }
        },
        [STYLE_COMPONENTS.INVENTORY_CAR_CARD]: {
            [STYLE_KEYS.WRAPPER]: {
                [SELLER_TYPES.LUXURY]: "styles.wrapperLuxury",
                [SELLER_TYPES.INTERNAL]: "styles.wrapper",
                [SELLER_TYPES.DEALER]: "styles.wrapper"
            },
            [STYLE_KEYS.CAR_BOTTOM_STRIP_WRAPPER]: {
                [SELLER_TYPES.LUXURY]: "styles.carBottomStripWrapperLuxury",
                [SELLER_TYPES.INTERNAL]: "styles.carBottomStripWrapper",
                [SELLER_TYPES.DEALER]: "styles.carBottomStripWrapper"
            }
        },
        [STYLE_COMPONENTS.CAR_DETAIL_ATF_HEADER]: {
            [STYLE_KEYS.LISTING_LABEL]: {
                [SELLER_TYPES.LUXURY]: "styles.luxuryListingLabel",
                [SELLER_TYPES.INTERNAL]: "styles.internalListingLabel",
                [SELLER_TYPES.DEALER]: "styles.dealerListingLabel"
            }
        },
        [STYLE_COMPONENTS.CDP_OVERVIEW]: {
            [STYLE_KEYS.OVERVIEW_WRAPPER]: {
                [SELLER_TYPES.LUXURY]: "styles.overviewWrapperLuxury",
                [SELLER_TYPES.INTERNAL]: "styles.overviewWrapper",
                [SELLER_TYPES.DEALER]: "styles.overviewWrapper"
            }
        },
        [STYLE_COMPONENTS.QUALITY_PROMISE]: {
            [STYLE_KEYS.RIGHT_PANEL]: {
                [SELLER_TYPES.LUXURY]: "styles.rightPanelLuxury",
                [SELLER_TYPES.INTERNAL]: "styles.rightPanel",
                [SELLER_TYPES.DEALER]: "styles.rightPanel"
            }
        }
    }
};

export const getSellerTypeStyle = (platform, component, styleKey, isLuxury, isInternal) => {
    const sellerType = isLuxury ? SELLER_TYPES.LUXURY
        : isInternal ? SELLER_TYPES.INTERNAL
            : SELLER_TYPES.DEALER;

    return SELLER_TYPE_STYLES[platform]?.[component]?.[styleKey]?.[sellerType] || "";
};

export const LEAD_APPOINTMENT_STATUS = {
    CONFIRM: "CONFIRM"
};

export const getCarFeaturesListColumns = (features, size) => {
    const columns = [];
    if (Array.isArray(features) && features.length > 0) {
        for (let i = 0; i < features.length; i += size) {
            columns.push(features.slice(i, i + size));
        }
    }
    return columns;
};

export const BREAKUP_DETAILS_TYPE = {
    pickupCharges: "pickupCharges",
    updateOfferedPrice: "updateOfferedPrice",
    costDueCarDetailsMismatch: "costDueCarDetailsMismatch",
    costDueCarFeaturesChanges: "costDueCarFeaturesChanges",
    serviceHistoryRevision: "serviceHistoryRevision",
    convenienceFee: "convenienceFee",
    cancelledConvenienceFee: "cancelledConvenienceFee",
    exclusiveCars24Bonus: "exclusiveCars24Bonus",
    finalOfferedPrice: "finalOfferedPrice",
    documentProceeding: "documentProceeding",
    regoTransfer: "regoTransfer",
    serviceCharge: "serviceCharge"
};

export const SOCIAL_MEDIA_KEYS = {
    FACEBOOK: "facebook",
    X: "x",
    INSTAGRAM: "instagram",
    LINKEDIN: "linkedin",
    YOUTUBE: "youtube"
};

export const SOCIAL_MEDIA_LINKS = {
    [SOCIAL_MEDIA_KEYS.FACEBOOK]: "https://www.facebook.com/cars24",
    [SOCIAL_MEDIA_KEYS.X]: "https://x.com/cars24",
    [SOCIAL_MEDIA_KEYS.INSTAGRAM]: "https://www.instagram.com/cars24",
    [SOCIAL_MEDIA_KEYS.LINKEDIN]: "https://www.linkedin.com/company/cars24",
    [SOCIAL_MEDIA_KEYS.YOUTUBE]: "https://www.youtube.com/cars24"
};

export const CORPORATE_ADDRESS = "118 Cherry Ln, Melbourne, Victoria, Laverton North VIC 3026";

export const WEB_FOOTER_SECTION = "WEB_FOOTER_SECTION";
